function getLanguage(currentLng){
    if (currentLng === 'th') {
      return "Thai";
    } else {
      return "English";
    }
  };

export default getLanguage;